import type {
  GetProductReviewsRequest,
  GetProductReviewsResponse,
  GetCuratedReviewsResponse,
  ReviewStatisticsRequest,
  ReviewStatisticsResponse,
} from "./utils/types";
import { client } from "../common/client";

class ReviewAPIClient {
  public async getProductReviews(
    productId: number,
    params?: Omit<GetProductReviewsRequest, "productId">,
  ): Promise<GetProductReviewsResponse> {
    return await client
      .get(`/reviews/product/${productId}`, { params, next: { revalidate: 5 } })
      .then((res) => res.json());
  }

  public async getCuratedReviews(): Promise<GetCuratedReviewsResponse> {
    return await client
      .get("/reviews/curated", { next: { revalidate: 5 } })
      .then((res) => res.json());
  }

  public async getReviewStatistics(
    params: ReviewStatisticsRequest,
  ): Promise<ReviewStatisticsResponse> {
    return await client
      .get("/reviews/statistics", { params, next: { revalidate: 5 } })
      .then((res) => res.json());
  }
}

export const reviewAPIClient = new ReviewAPIClient();
